<template>
  <div class="flex min-h-full flex-1 flex-col justify-center pt-24 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <WordmarkLogo class="mx-auto" />
    </div>

    <div class="mt-6 sm:mx-auto sm:w-full sm:max-w-[480px]">
      <div class="px-6 pb-6 sm:rounded-lg sm:px-12">
        <p class="mx-auto mb-10 flex justify-center text-xl font-semibold">{{ t("msg.twoFactorAuth") }}</p>
        <form class="space-y-2" @submit.prevent="handleLogin">
          <p v-if="errorMessage" class="text-[#e05454]">{{ t("msg.error") }}: {{ errorMessage }}</p>
          <Input
            type="text"
            model-label="msg.code"
            model-name="Code"
            :model-value="codeInput"
            :color="`${theme}${highContrast ? '-hc' : ''}`"
            @update:model-value="(c) => (codeInput = c)"
            autofocus
          />

          <div>
            <button
              type="submit"
              :class="globals.btnClass(theme, highContrast)"
              class="mt-6 flex w-full justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm"
            >
              {{ t("msg.login") }}
            </button>
          </div>
          <p class="cursor-pointer text-white" @click="logout">{{ t("msg.backToLogin") }}</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import authService from "../services/auth.service.ts";
import Input from "../components/Input.vue";
import globals from "../globals";
import { useColorMode } from "@vueuse/core";

import { useI18n } from "vue-i18n";
import WordmarkLogo from "../components/WordmarkLogo.vue";
import { useAuthStore } from "../pinia/auth.ts";

const { t } = useI18n();

const authStore = useAuthStore();
authStore.fetchTheme();
authStore.fetchHighAccessibility();

const router = useRouter();
const route = useRoute();

const theme = computed(() => authStore.theme.Accent);
const highContrast = computed(() => authStore.theme.HighAccessibility);
const errorMessage = ref("");
const codeInput = ref(null);

useColorMode({
  initialValue: "dark",
});

const handleLogin = () => {
  const credentials = {
    Code: codeInput.value,
  };

  authService.twoFactorVerify(credentials).then(
    async () => {
      const status = await authStore.fetchStatus();
      authStore.fetchTheme();

      if (status.NewUserDashboard) {
        router.push({ path: "/home/new", query: route.query });
      } else {
        router.push({ path: "/home", query: route.query });
      }
    },
    (error) => {
      errorMessage.value = globals.renderError(t, error);
    },
  );
};

const logout = async () => {
  try {
    await authStore.logout();
  } finally {
    router.push({ name: "Login", query: route.query });
  }
};
</script>
